import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from 'ui-components/components/checkbox';

import { MarkAsShippedContext } from '../../../context';
import { MARK_AS_SHIPPED_DEDUCT_INVENTORY } from '../../../constants';
import { stopPropagation } from '../../../helper';

import style from '../style.module.less';

const OrderNumber = ({ fulfillmentPlanId }) => {
  const {
    fulfillmentPlans: { [fulfillmentPlanId]: { deductInventory } = {} },
    updateFulfillmentPlan,
  } = useContext(MarkAsShippedContext);

  const onClick = useCallback(() => {
    updateFulfillmentPlan(fulfillmentPlanId, MARK_AS_SHIPPED_DEDUCT_INVENTORY, !deductInventory);
  }, [updateFulfillmentPlan, fulfillmentPlanId, deductInventory]);

  return (
    <div className={style.checkbox} onClick={stopPropagation}>
      <Checkbox checked={deductInventory} onChange={onClick} />
    </div>
  );
};

OrderNumber.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default OrderNumber;
